<ng-container *transloco="let convert;">
  <div class="images-count-container">
    <div class="images-count">
      <div class="images-count__number">
        <div class="images-count__number-inner">{{ count }} <span class="visually-hidden">{{convert('common.labelImages')}}</span></div>
      </div>

      <div class="image-container">
        <lib-placeholder></lib-placeholder>
        @if (img) {
          <img class="image" [src]="img" alt="" (error)="image.style.display = 'none'" #image/>
        }
      </div>
    </div>
  </div>
</ng-container>
